import React from 'react'

import TodayTasksPanel from './TodayTasksPanel';
import { AllQuestions } from './AllQuestions';


export const DsaTracker = () => {

      


  return (
     <div className="w-full h-screen flex">
      {/* LEFT SECTION - 65% */}
      <div className="w-[65%] h-full flex flex-col">

        {/* LEFT TOP - 25% */}
        <div className="h-[25%] bg-blue-300 flex items-center justify-center">
          Left Top (25%)
        </div>

        {/* LEFT BOTTOM - 75% */}
        <div className="h-[75%] bg-blue-500 flex items-center justify-center">
          <AllQuestions/>
        </div>
      </div>
      {/* RIGHT SECTION - 35% */}
      <div className="w-[35%] h-full flex flex-col">
        {/* RIGHT TOP - 35% */}
        <div className="h-[35%] bg-blue-800 flex items-center justify-center">
          <TodayTasksPanel/>
        </div>
        {/* RIGHT BOTTOM - 65% */}
        <div className="h-[65%] bg-green-500 flex items-center justify-center">
            RIGHT bottom (35%)
        </div>
      </div>
    </div>
  )
}
